import React, { FC } from 'react';
import PermissionsListPage from './permission-list';
import { Route, Routes } from 'react-router-dom';
// import PermissionDetailsPage from './permission-details';

const PermissionsIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<PermissionsListPage />} />
      {/* <Route exact path={`${match.url}/:id`} component={PermissionDetailsPage} /> */}
    </Routes>
  );
};

export default PermissionsIndex;
